import { render, staticRenderFns } from "./group-chat-panel.vue?vue&type=template&id=928a59ba&scoped=true&"
import script from "./group-chat-panel.vue?vue&type=script&lang=js&"
export * from "./group-chat-panel.vue?vue&type=script&lang=js&"
import style0 from "./group-chat-panel.vue?vue&type=style&index=0&id=928a59ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928a59ba",
  null
  
)

export default component.exports